import React, { useState } from 'react';
import style from '../style.module.css';
import { NavLink } from "react-router-dom";
import { LogoMobile, MobileMenu } from '../../../assets';

const MobileNav = () => {
    const [menuDropdown, toggleMenuDropdown] = useState(false)
    return (
        <>
            <div className={['mobile__nav', style.mobile__nav_wrapper].join(" ")}>
                <LogoMobile />
                <MobileMenu onClick={() => toggleMenuDropdown(!menuDropdown)} />

            </div>
            {
                menuDropdown &&
                <div className={style.menu__dropdown}>
                    <NavLink
                    to="/"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                    onClick={() => toggleMenuDropdown(false)}
                >
                    Home
                </NavLink>
                {/* <NavLink
                    to="/services"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                    onClick={() => toggleMenuDropdown(false)}
                >
                    Services
                </NavLink> */}
                <NavLink
                    to="/about-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                    onClick={() => toggleMenuDropdown(false)}
                >
                    About Us
                </NavLink>
                <NavLink
                    to="/contact-us"
                    className={({ isActive, isPending }) =>
                        isPending ? "pending" : isActive ? style.active : ""
                    }
                    onClick={() => toggleMenuDropdown(false)}
                >
                    Contact Us
                </NavLink>
                </div>
            }
        </>
    )
}

export default MobileNav